import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube, FaWhatsapp, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { brandLogo } from '../config/brandAssets';
import { usePublicPaths } from '../routes/publicPaths';
import { useSiteSettings } from '../hooks/useSiteSettings';
import { whatsappHref, telHref, mailHref } from '../utils/contactLinks';
import VolunteerRequestTrigger from './VolunteerRequestTrigger';
import './SiteFooter.css';

const SiteFooter = () => {
  const { t } = useTranslation();
  const paths = usePublicPaths();
  const settings = useSiteSettings();
  const wa = whatsappHref(settings.whatsapp || settings.phone);
  const phone = telHref(settings.phone);
  const email = mailHref(settings.email);

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <img src={brandLogo} alt={t('public.brand.name')} className="site-footer__logo" />
          <p className="site-footer__name">{t('public.brand.name')}</p>
          {settings.address && (
            <p className="site-footer__address">
              <FaMapMarkerAlt /> {settings.address}
            </p>
          )}
        </div>

        <nav className="site-footer__nav" aria-label={t('public.nav.footerNav')}>
          <Link to={paths.home}>{t('public.nav.home')}</Link>
          <Link to={paths.programmes}>{t('public.nav.allPrograms')}</Link>
          <Link to={paths.donate}>{t('public.nav.donate')}</Link>
          <VolunteerRequestTrigger className="volunteer-footer-btn">{t('public.nav.volunteer')}</VolunteerRequestTrigger>
          <Link to={paths.actualites}>{t('public.nav.news')}</Link>
          <Link to={paths.about}>{t('public.nav.whoWeAre')}</Link>
          <Link to={paths.legal}>{t('public.nav.legal')}</Link>
        </nav>

        <div className="site-footer__contact">
          {phone && (
            <a href={phone}>
              <FaPhone /> {settings.phone}
            </a>
          )}
          {email && (
            <a href={email}>
              <FaEnvelope /> {settings.email}
            </a>
          )}
          {wa && (
            <a href={wa} target="_blank" rel="noopener noreferrer">
              <FaWhatsapp /> WhatsApp
            </a>
          )}
          <div className="site-footer__social">
            {settings.facebook && (
              <a href={settings.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebook />
              </a>
            )}
            {settings.instagram && (
              <a href={settings.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
            )}
            {settings.twitter && (
              <a href={settings.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <FaTwitter />
              </a>
            )}
            {settings.youtube && (
              <a href={settings.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <FaYoutube />
              </a>
            )}
          </div>
        </div>
      </div>
      <div className="site-footer__copy">© {new Date().getFullYear()} {t('public.brand.name')}</div>
    </footer>
  );
};

export default SiteFooter;
